import { z } from 'zod/v4'

export const CustomDataValidator = z.object({
	id: z.string(),
	metadata: z.record(z.string(), z.any()),
})

export const AddressValidator = z.object({
	query_id: z.string().optional(),
	address1: z.string(),
	address2: z.string().optional(),
	city: z.string(),
	state: z.string(),
	zip: z.string(),
	iso_country_code: z.literal('US'),
	latitude: z.string().optional(),
	longitude: z.string().optional(),
})

export const AddressDataPointValidator = z.object({
	address: AddressValidator,
	metadata: z.record(z.string(), z.any()),
})

export const LatLngDataPointValidator = z.object({
	latitude: z.number(),
	longitude: z.number(),
	metadata: z.record(z.string(), z.any()),
})

export const ZipcodeDataPointValidator = z.object({
	zipcode: z.string(),
	metadata: z.record(z.string(), z.any()),
})

export type CustomData = z.infer<typeof CustomDataValidator>
export type Address = z.infer<typeof AddressValidator>
export type AddressDataPoint = z.infer<typeof AddressDataPointValidator>
export type LatLngDataPoint = z.infer<typeof LatLngDataPointValidator>
export type ZipcodeDataPoint = z.infer<typeof ZipcodeDataPointValidator>

export type H3CellMetadataMap = Map<string, Map<string, number>>
